import rewriteToFixed from '../utils/rewriteToFixed.js'
import CustomTooltip from '../utils/custom-tooltip';

function orderDetailsTemplate(data) {
	const {
		amount: {
			meta: {
				totalCouponSaved,
				totalMembershipSaved,
				totalOrderCredit,
				totalPackageSaved,
				totalBeforeFees,
				quantityTotal,
				entireStoreDiscountPercentMoneySaved,
				productSubTotal,
				generalProductTotal,
				total,
				facilityFeeTotal,
				totalFacilityFeeRemoved,
				ticketTotal,
				convenienceFeeTotal,
				totalConvenienceFeeRemoved,
				orderProcessingFeeStoreCharge,
				totalOrderProcessingFeeRemoved,
				shippingFee,
				handlingFee,
				shippingAndHandlingFee,
				taxAmount,
				TaxLabel,
				orderCredit,
				orderAdjustment,
				giftCardRedeem,
			},
			items,
		},
		itemsTicket,
		itemsNonTicket,
		assignSeatNumberAfterPayment,
		assignSeatNumberAfterPaymentMessage,
		redeemableEvents,
		giftCardCheckout,
		termFacilityFee,
		termTicketingFee,
		reserveTickets,
		reserveTicketsGetFee,
		ticketsMessage: { contiguousMessage, seatMessage, orphanMsg },
		auditoriumName,
		eventName,
		orderChecksum,
	} = data
	const myItems = Object.values(items)
	const quantity = myItems.length
	const totalSaved = [
		{
			label: window.myvars['Coupon Discount'],
			value: totalCouponSaved,
		},
		{
			label: window.myvars['Membership Discount'],
			value: totalMembershipSaved,
		},
		{
			label: window.myvars['Order Credit'],
			value: totalOrderCredit,
		},
		{
			label: window.myvars['Entire Store Discount'],
			value: entireStoreDiscountPercentMoneySaved,
		},
		{
			label: window.myvars['Package Redeemed'],
			value: totalPackageSaved,
		},
	]

	const metaFees = [
		{
			label: termFacilityFee || window.myvars['Facility Fee'],
			value:
				(parseFloat(facilityFeeTotal) > 0 || parseFloat(totalFacilityFeeRemoved) > 0)
					? facilityFeeTotal
					: null,
			class: "facilityFeeTooltip",
			msg: "Facility fee is required by the venue to cover the cost of operating the facility.",
		},
		{
			label: termTicketingFee || window.myvars['Ticketing Fee'],
			value:
				(parseFloat(convenienceFeeTotal) > 0 || parseFloat(totalConvenienceFeeRemoved) > 0)
					? convenienceFeeTotal
					: null,
			class: "ticketingFeeTooltip",
			msg: "Ticketing fees help cover the costs of organizing the event and are shared among the various entities involved.",
		},
		{
			label: window.myvars['Order Processing Fee'],
			value:
				(parseFloat(orderProcessingFeeStoreCharge) > 0 || parseFloat(totalOrderProcessingFeeRemoved) > 0)
					? orderProcessingFeeStoreCharge
					: null,
			class: "orderProcessingFeeTooltip",
			msg: "Order processing fees cover administrative costs associated with the purchase and customer support.",
		},
		{
			label: window.myvars['Shipping & Handling'],
			value:
				!isNaN(shippingFee) || !isNaN(handlingFee)
					? shippingAndHandlingFee
					: null,
		},
		{
			label: TaxLabel,
			value: parseFloat(taxAmount) > 0 ? taxAmount : null,
			class: "taxTooltip",
			msg: "Applicable local, city, and state taxes are included.",
		},
		{
			label: window.myvars['Previous Order Credit'],
			value: parseFloat(orderCredit) > 0 && `-${orderCredit}`,
		},
		{
			label: window.myvars['Order Adjustment'],
			value: orderAdjustment,
		},
		{
			label: window.myvars['Your deposit'],
			value: reserveTickets && reserveTicketsGetFee,
		},
	]

	return `
    <div class="">
    	${!giftCardCheckout ? header(itemsTicket, eventName, auditoriumName, orderChecksum) : ''}
			<details class='relative cartDetails mb-10'>
				<summary class="flex justify-between cursor-pointer text-[1rem]">
					<div class='font-bold'>${window.myvars.total} (${quantityTotal})</div>
					<div class="flex">
							<div class='font-bold'>${window.Locale.formatCurrency(
		total,
		window.myvars.langCode
	)}</div>
					</div>
					<span class="arrowDown absolute summary__arrowDown"></span>
				</summary>
				<div class='content'>
					<div class="flex justify-between help">
						<span>${itemsTicket.length} ${window.myvars.tickets} ${itemsNonTicketLabel(itemsNonTicket)}</span>
						<span>${window.Locale.formatCurrency(
		totalBeforeFees,
		window.myvars.langCode
	)}</span>
					</div>
					${totalSavedMap(totalSaved)}
					<div class='cartDetails__seatMap text-gray'>
						<header class="grid itemLine itemLine__header">
							<span class="seat-icon"></span>
							<span class="a-left">${window.myvars.section}</span>
							<span class="a-right">${window.myvars.row}</span>
							<span class="a-right">${window.myvars.seat}</span>
							<span class="a-right"></span>
						</header>
						${itemsTicketMap(itemsTicket)}
					</div>
					${Number(assignSeatNumberAfterPayment) > 0
			? `
						<div class="help">${assignSeatNumberAfterPaymentMessage}</div>
					`
			: ''
		}
					${itemsNonTicketTemplate(itemsNonTicket)}
					${metaFeesMap(metaFees)}
					${contiguousMessage || seatMessage.length > 0 || orphanMsg
			? messagesWrapper(contiguousMessage, orphanMsg, seatMessage)
			: ''
		}
				</div>
			</details>
    </div>
	`
}

function header(itemsTicket, eventName, auditoriumName, orderChecksum) {
	if (itemsTicket.length > 0) {
		return `
			<header class='mb-20 mt-5'>
				<div class="text-center text-[1rem]">
					${itemsTicket[0].timeStartDisplay}
				</div>
				<div class="text-center text-[12px]">${auditoriumName}</div>
			</header>
			<input type="hidden" name="orderChecksum" value="${orderChecksum}">
		`
	}

	if (eventName) {
		return `
			<h5 class="review-cart-title-style text-center">
				${eventName}
			</h5>
			<h5 class="review-cart-title-style text-center">${auditoriumName}</h5>
		`
	}
}

function totalSavedMap(totalSaved) {
	return totalSaved
		.map((item) => {
			const { label, value } = item
			if (value) {
				return `
					<div class="flex justify-between">
						<div class="orderSummary__label">
							${label}
						</div>
						<div class="orderSummary__value">
								-${window.Locale.formatCurrency(value, window.myvars.langCode)}
						</div>
					</div>
				`
			}

			return ''
		})
		.join('')
}

function seatIcon(seatType) {
	switch (seatType) {
		case '1':
			return '<span class="seat-icon icon-svg icon-svg--size-16 icon-wheelchair special-seat-icon"></span>'
		case '2':
			return '<span class="seat-icon icon-svg--size-14 c-special-seat-icon">C</span>'
		case '8':
			return '<span class="seat-icon icon-svg--size-14 o-special-seat-icon">O</span>'
		case '4':
			return '<span class="seat-icon icon-svg--size-14 t-special-seat-icon">T</span>'
		default:
			return '<span class="seat-icon"></span>'
	}
}
function itemsTicketMap(itemsTicket) {
	return itemsTicket
		.map((item) => {
			const { sectionNameDisplay, rowLabel, columnLabel, priceDisplay, product } = item
			console.log(item)
			return `
			<div class="grid itemLine items-start" style="margin-bottom: 8px; margin-top: 3px;">
				${seatIcon(product.seatType)}
				<span class="a-left leading-[1.1]">${sectionNameDisplay}</span>
				<span class="a-right leading-[1.1]">${rowLabel}</span>
				<span class="a-right leading-[1.1]">${columnLabel}</span>
				<span class="a-right leading-[1.1]">
				${priceDisplay}
				${item.discountName ? `<span class="discount-name leading-[1.1]">${item.discountName}</span>` : ''}
				</span>
			</div>
		`
		})
		.join('')
}

function itemsNonTicketTemplate(itemsNonTicket) {
	if (itemsNonTicket.length > 0) {
		return `
			<div class='cartDetails__seatMap text-gray'>
				<header class="grid itemLine itemLine__header">
					<Span class="a-left leading-[1.45]"></Span>
					<span class="a-right leading-[1.45]">${window.myvars.price}</span>
					<span class="a-right leading-[1.45]">${window.myvars.qty}</span>
					<span class="a-right leading-[1.45]"></span>
				</header>
				${itemsNonTicketMap(itemsNonTicket)}
				</div>
		`
	}

	return ''
}

function itemsNonTicketLabel(itemsNonTicket) {
	if (itemsNonTicket.length > 0) {
		let qty = 0
		itemsNonTicket.forEach((item) => {
			const { quantity } = item
			qty += Number(quantity)
		})

		return `+ ${qty} ${window.myvars.products}`
	}

	return ''
}

function itemsNonTicketMap(itemsNonTicket) {
	return itemsNonTicket
		.map((item) => {
			const { name, price, quantity } = item
			return `
			<div class="grid itemLine">
				<Span class="a-left leading-[1.45]">${name}</Span>
				<span class="a-right leading-[1.45]">${window.Locale.formatCurrency(
				price,
				window.myvars.langCode
			)}</span>
				<span class="a-right leading-[1.45]">${quantity}</span>
				<span class="a-right leading-[1.45]">${window.Locale.formatCurrency(
				// (price * quantity).toFixed(2),
				rewriteToFixed(price * quantity, 2),
				window.myvars.langCode
			)}</span>
			</div>
		`
		})
		.join('')
}

function metaFeesMap(metaFees) {
	return metaFees
		.map((item) => {
			const { label, value } = item
			window.tooltip = new CustomTooltip();
			if (value) {
				return typeof item["class"] !== "undefined" ?
					`<div class="flex justify-between help">
						<div class="orderSummary__label flex items-center" data-tooltip=${item["msg"]}>
							${label} ${(window.tooltip.createInfoIcon(window.myvars[item["class"]]))}
						</div>
						<div class="orderSummary__value">
								${window.Locale.formatCurrency(value, window.myvars.langCode)}
						</div>
					</div>`
					:
					`<div class="flex justify-between help">
						<div class="orderSummary__label">
							${label}
						</div>
						<div class="orderSummary__value">
								${window.Locale.formatCurrency(value, window.myvars.langCode)}
						</div>
					</div>
				`
			}

			return ''
		})
		.join('')
}

function messages(seatMessage) {
	return Object.entries(seatMessage)
		.map(([key, message]) => {
			return `
				<div class='seat-message-item'>
						<span class='seat-icon syr-glyphs syr-info'></span>
						<div class='item-centent'><strong>${key}</strong>: ${message}</div>
				</div>
		`
		})
		.join('')
}

function messagesWrapper(contiguousMessage, orphanMsg, seatMessage) {
	const messagesArr = [contiguousMessage, orphanMsg]
	return `
	<div class="seat-message-block">
		${messagesArr
			.map((item) => {
				if (item) {
					return `<div class="seat-message-item">
						 <span class="seat-icon syr-glyphs syr-info"></span>
						 <div class='item-centent'>${item}</div>
					</div>`
				}

				return ''
			})
			.join('')}
		${seatMessage ? messages(seatMessage) : ''}
		</div>
	`
}

export default orderDetailsTemplate
